<script setup lang="ts"></script>

<template>
  <icon name="lucide:grip-horizontal" />
</template>

<style scoped></style>
